import { createApp } from 'vue';

var app = createApp({

    data() {
        return {
            request_catalogue: {
                purpose: '',
                products_have_image: 'yes',
                products_have_title_and_description: 'yes',
                catalogue_print: 'yes',
                name: '',
                email: '',
                message: ''
            },
            errors: {
                purpose: false,
                name: false,
                email: false,
                message: false
            },
            sending_help: false,

            purposes: [
                {
                    id: "sales",
                    label_id: "request_brochure_purpose_sales"
                },
                {
                    id: "showcase",
                    label_id: "request_brochure_purpose_showcase"
                },
                {
                    id: "presentation",
                    label_id: "request_brochure_purpose_presentation"
                }
            ],

            ui: {
                show_error_field: false,
                show_confirmation_block: false,
            }
        }
    },

    created: function () {
    },

    mounted: function () {
        console.log("request_catalogue",this.request_catalogue);
        
    },

    destroyed() {
    },

    computed: {
    },

    components: {
    },

    methods: {

        sendHelpRequest: function (ev) {

            var self = this;

            var has_errors = false;

            if (!self.request_catalogue.purpose) {
                self.errors.purpose = true;
                has_errors = true;
            } else {
                self.errors.purpose = false;
            }

            if (!self.request_catalogue.name) {
                self.errors.name = true;
                has_errors = true;
            } else {
                self.errors.name = false;
            }

            if (!self.request_catalogue.email) {
                self.errors.email = true;
                has_errors = true;
            } else if (!self.request_catalogue.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
                self.errors.email = true;
                has_errors = true;
            } else {
                self.errors.email = false;
            }

            if (has_errors) {
                self.ui.show_error_field = true;

                ev.preventDefault();
                ev.stopPropagation();
            }
        },
    }
});

app.mount('#vue_request_brochure_app');